import { ErrorBoundary } from '@sentry/react';
import React, { Suspense, useState } from 'react';

import { TableSkeleton } from '@eluve/blocks';
import {
  Button,
  Content,
  Header,
  Heading,
  Icon,
  SidebarTrigger,
  Stack,
} from '@eluve/components';
import { FilterableClinicalTasksTable } from '@eluve/feature-clinical-tasks';
import { useCaptureEventOnMount } from '@eluve/posthog-react';

export const TasksListPage: React.FC = () => {
  useCaptureEventOnMount('page_view_tasks_list');
  // Owned here so the "New task" button can sit in the header beside Print,
  // while the create sheet + refetch stay with the table.
  const [creating, setCreating] = useState(false);

  return (
    <>
      <Header>
        <SidebarTrigger />
        <Stack
          direction="horizontal"
          align="center"
          justify="between"
          className="my-2 py-2"
        >
          <Heading>Tasks</Heading>
          <Stack
            direction="horizontal"
            align="center"
            fullWidth={false}
            gap={2}
          >
            <Button variant="outline" size="sm" onClick={() => window.print()}>
              <Icon name="Printer" size="sm" />
              Print
            </Button>
            <Button
              size="sm"
              onClick={() => setCreating(true)}
              data-testid="clinical-tasks-new-task"
            >
              <Icon name="Plus" size="sm" />
              New task
            </Button>
          </Stack>
        </Stack>
      </Header>
      <Content padded>
        <Suspense fallback={<TableSkeleton rowCount={20} />}>
          <ErrorBoundary
            fallback={
              <Stack gap={2}>
                <p>Failed to load tasks.</p>
                <TableSkeleton rowCount={5} />
              </Stack>
            }
          >
            <FilterableClinicalTasksTable
              creating={creating}
              onCreatingChange={setCreating}
            />
          </ErrorBoundary>
        </Suspense>
      </Content>
    </>
  );
};
